import { RelatedIcon } from "../icons/RelatedIcon";

export interface SimilarityTextProps {
  cacheType: string;
  score: number;
  hasSimilarPrompt: boolean;
}

const SimilarityText = ({
  cacheType,
  score,
  hasSimilarPrompt,
}: SimilarityTextProps) => {
  if (cacheType === "original" || (cacheType === "similar" && score === 0)) {
    return <>Exact match</>;
  } else if (cacheType === "similar" || hasSimilarPrompt) {
    return (
      <>
        Similarity match -{" "}
        {score > 0
          ? Intl.NumberFormat("en-US", {
              style: "percent",
              maximumFractionDigits: 2,
            }).format(1 - score)
          : "similar prompt"}
        <span className="ms-1">
          <RelatedIcon size={14} />
        </span>
      </>
    );
  }

  return null;
};

export { SimilarityText };
